// @ts-nocheck
// fetch all estimates
export const FETCH_ESTIMATES_REQUEST = "FETCH_ESTIMATES_REQUEST";
export const FETCH_ESTIMATES_SUCCESS = "FETCH_ESTIMATES_SUCCESS";
export const FETCH_ESTIMATES_FAILURE = "FETCH_ESTIMATES_FAILURE";

// fetch old commentjsk messages
export const FETCH_OLD_COMMENTS_REQUEST = "FETCH_OLD_COMMENTS_REQUEST";
export const FETCH_OLD_COMMENTS_SUCCESS = "FETCH_OLD_COMMENTS_SUCCESS";
export const FETCH_OLD_COMMENTS_FAILURE = "FETCH_OLD_COMMENTS_FAILURE";

// send message
export const POST_COMMENT_REQUEST = "POST_COMMENT_REQUEST";
export const POST_COMMENT_SUCCESS = "POST_COMMENT_SUCCESS";
export const POST_COMMENT_FAILURE = "POST_COMMENT_FAILURE";

// post the applied rate
export const POST_APPLIED_RATE_REQUEST = "POST_APPLIED_RATE_REQUEST";
export const POST_APPLIED_RATE_SUCCESS = "POST_APPLIED_RATE_SUCCESS";
export const POST_APPLIED_RATE_FAILURE = "POST_APPLIED_RATE_FAILURE";
export const POST_APPLIED_RATE_EVENT_REQUEST_REQUEST =
  "POST_APPLIED_RATE_EVENT_REQUEST_REQUEST";
export const POST_APPLIED_RATE_EVENT_REQUEST_FAILURE =
  "POST_APPLIED_RATE_EVENT_REQUEST_FAILURE";

// post the applied rate
export const POST_CLIENT_PREFERRED_RATE_AND_NOTES_REQUEST =
  "POST_CLIENT_PREFERRED_RATE_AND_NOTES_REQUEST";
export const POST_CLIENT_PREFERRED_RATE_AND_NOTES_SUCCESS =
  "POST_CLIENT_PREFERRED_RATE_AND_NOTES_SUCCESS";
export const POST_CLIENT_PREFERRED_RATE_AND_NOTES_FAILURE =
  "POST_CLIENT_PREFERRED_RATE_AND_NOTES_REQUEST";

// approve event
export const APPROVE_EVENT_REQUEST = "APPROVE_EVENT_REQUEST";
export const APPROVE_EVENT_SUCCESS = "APPROVE_EVENT_SUCCESS";
export const APPROVE_EVENT_FAILURE = "APPROVE_EVENT_FAILURE";

// approve event by client
export const APPROVE_EVENT_REQUEST_BY_CLIENT_REQUEST =
  "APPROVE_EVENT_REQUEST_BY_CLIENT_REQUEST";
export const APPROVE_EVENT_SUCCESS_BY_CLIENT_SUCCESS =
  "APPROVE_EVENT_SUCCESS_BY_CLIENT_SUCCESS";
export const APPROVE_EVENT_FAILURE_BY_CLIENT_FAILURE =
  "APPROVE_EVENT_FAILURE_BY_CLIENT_FAILURE";

// reject event estimate
export const REJECT_EVENT_REQUEST = "REJECT_EVENT_REQUEST";
export const REJECT_EVENT_SUCCESS = "REJECT_EVENT_SUCCESS";
export const REJECT_EVENT_FAILURE = "REJECT_EVENT_FAILURE";

// newEstimateRequest
export const NEW_ESTIMATE_REQUEST = "NEW_ESTIMATE_REQUEST";
export const NEW_ESTIMATE_SUCCESS = "NEW_ESTIMATE_SUCCESS";
export const NEW_ESTIMATE_FAILURE = "NEW_ESTIMATE_FAILURE";

// empty client esimate list
export const EMPTY_CLIENT_ESTIMATE_LIST = "EMPTY_CLIENT_ESTIMATE_LIST";

// get all submitted estimate
export const GET_ALL_SUBMITTED_ESTIMATES_REQUEST =
  "GET_ALL_SUBMITTED_ESTIMATES_REQUEST";
export const GET_ALL_SUBMITTED_ESTIMATES_SUCCESS =
  "GET_ALL_SUBMITTED_ESTIMATES_SUCCESS";
export const GET_ALL_SUBMITTED_ESTIMATES_FAILURE =
  "GET_ALL_SUBMITTED_ESTIMATES_FAILURE";

// update po number
export const UPDATE_PO_NUMBER_REQUEST = "UPDATE_PO_NUMBER_REQUEST";
export const UPDATE_PO_NUMBER_SUCCESS = "UPDATE_PO_NUMBER_SUCCESS";
export const UPDATE_PO_NUMBER_FAILURE = "UPDATE_PO_NUMBER_FAILURE";